import type { ReactNode } from "react";
import type { DownloadableClip } from "../download";
import { formatClipDate } from "../formatDate";

/**
 * Wraps the (untouched) Bitmovin player with a title/date panel below it.
 * The player is passed as children rather than reimplemented here - its
 * seeking/autoplay/clip-transition logic is too load-bearing to risk
 * rewriting for a visual refresh.
 *
 * Nothing here styles the video itself: no background behind it and no
 * rounded clipping over it, so the player renders exactly as it sizes
 * itself. Downloading lives on the clip rows in the list beside this.
 */
export function VideoPlayerCard({
  currentVideoData,
  children,
}: {
  currentVideoData: DownloadableClip | undefined;
  children: ReactNode;
}) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white">
      {children}

      <div className="min-w-0" style={{ padding: "16px" }}>
        {currentVideoData?.event_type && (
          <div className="text-action text-[11px] font-extrabold uppercase tracking-wide">
            {currentVideoData.event_type}
          </div>
        )}
        <div className="font-bold text-slate-900 truncate">
          {currentVideoData?.away_team_name} vs {currentVideoData?.home_team_name}
        </div>
        {currentVideoData?.game_date && (
          <div className="text-sm text-slate-500">
            Played {formatClipDate(currentVideoData.game_date)}
          </div>
        )}
      </div>
    </div>
  );
}
